import ScheduledTasksView from "./ScheduledTasksView";

export default [
  {
    path: "/scheduled_tasks",
    name: "admin_scheduled_tasks",
    component: ScheduledTasksView,
    meta: {
      tabAccess: "ADMIN",
    },
  },
];
